<template>
    <div class="kryptium-button " v-bind:class="color">
      <div v-bind:class="{'fade-effect':showBlinkClass}" class="overlay"></div>
      <div v-html="betInfo.displayedText"></div>
    </div>
</template>

<script>
export default {
  props:{
    color:String,
    betInfo:Object,
    displayedText:[String, Number]
  },
  watch:{
    betInfo:function(newValue,oldValue){
      if( oldValue !== null && oldValue.displayedText !== "" && oldValue.displayedText !== "&mdash;" && newValue.displayedText !== oldValue.displayedText && newValue.runnerId === oldValue.runnerId){
        this.showBlinkClass = true;
        setTimeout(function () {
          this.showBlinkClass = false;
        }.bind(this),400)
      }
    },
    // displayedText:function (newValue,oldValue) {
    //   if(oldValue !== "" && oldValue !== null && oldValue !== "&mdash;" && newValue !== oldValue){
    //     this.showBlinkClass = true;
    //     setTimeout(function () {
    //       this.showBlinkClass = false;
    //     }.bind(this),400)
    //   }
    // }
  },
  data:function(){
    return {
      showBlinkClass:false
    }
  },
  name: 'kryptButton',
  computed:{}
};
</script>

<style scoped>

  .fade-effect{
    opacity: 0.6 !important;
  }

  .overlay{
    content: "";
    background-color: var(--the-flash);
    position:absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 0.4s ease-in-out;
    will-change: opacity;
    border-radius: 4px;
  }

  .kryptium-button{
    /*display: flex;*/
    flex-direction: row;
    align-items: center;
    padding:  8px 0px 8px 0px;
    /*padding: 8px;*/
    border-radius: 4px;
    height: 35px;
    max-width: 61px;
    width: 100%; /* old:  calc(50% - 6px); , also: left/right margin went to container padding */
    text-align: center;
    font-size:14px;
    line-height: 19px;
    font-weight: bold;
    /*align-items: center;*/
    display: inline-flex;
    flex: 0 0 auto;
    justify-content: center;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    vertical-align: middle;
    white-space: nowrap;
    cursor: pointer;
  }
  .superman{
    background: #0462B9;
    color: white;
  }
  .superman:hover {
    background: #03529B;
  }
  .lex-luthor{
    background: #009E3D;
    color: white;
  }
  .lex-luthor:hover {
    background: #008533;
  }
  .default{
    color: var(--grey-600);
    background: var(--grey-300);
  }
  .default:hover{
    background: var(--grey-300-state);
  }

</style>
